import { AgencyModel } from './../models/Common/AgencyModel';
import { VehicleReservationsPopularDealsModel, VehicleReservationsPopularDealsTemplate } from './../models/Common/VehicleReservationsPopularDealsModel';
import { ApiControllerActionEnum } from './../models/enums/ApiControllerActionEnum';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VehicleReservationsStatisticModel } from 'src/app/models/Common/VehicleReservationsStatisticModel'
import {EvaluationClientsLogsModel} from 'src/app/models/Common/EvaluationClientsLogsModel'
import { ResourceService } from './resource.service';
import { CurrencyModel } from '../models/CurrencyModel';
import { LanguageModel } from '../models/LanguageModel';
import { ContactModel } from '../models/Common/ContactModel';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  selectedCurrency: CurrencyModel;
  selectedLanguage: LanguageModel;
  selectedLanguageIsoCode: string;

  constructor(private http: HttpClient,private resouceService: ResourceService) {

    resouceService.selectedCurrency.subscribe(res => this.selectedCurrency = res);
    //Default isocode
    this.selectedLanguageIsoCode = "en";
    resouceService.selectedLanguage.subscribe(res => {

      this.selectedLanguage = res;
      if (res != null) {
        this.selectedLanguageIsoCode = res.isoCode2;
      }
    })

  }

  getVehicleReservationsStatistic() {
    return this.http.get<VehicleReservationsStatisticModel>(ApiControllerActionEnum.GetVehicleReservationsStatistic);
  }

  getEvaluationClientsLogs(pageSize,pageNumber) {
    return this.http.get<Array<EvaluationClientsLogsModel>>(ApiControllerActionEnum.GetEvaluationClientsLogs+`?pageSize=${pageSize}&pageNumber=${pageNumber}`);
  }
  getVehicleReservationsPopularDealsStatistics(){
    let lang="en"
    return this.http.get<VehicleReservationsPopularDealsTemplate>(ApiControllerActionEnum.GetVehicleReservationsPopularDealsStatistics+`?lang=${lang}`);
  }

  getAgencies(pageSize?,pageNumber?){
    let params=`?lang=${this.selectedLanguageIsoCode}`;
    if(pageSize!=null){
      params+=`&pageSize=${pageSize}`
    }
    if(pageNumber!=null){
      params+=`&pageNumber=${pageNumber}`
    }
    return this.http.get<Array<AgencyModel>>(ApiControllerActionEnum.GetAgencies+params);
  }

  
  onContactUs(messageContent) {
    return this.http.post<ContactModel>(ApiControllerActionEnum.ContactUS, JSON.stringify(messageContent))
  }

}
